import areaRoutes from './area/area.routes.js';
import deviceTypeRoutes from './deviceType/deviceType.routes.js';
import deviceRoutes from './device/device.routes.js';
import checkContentRoutes from './checkContent/checkContent.routes.js';
import dailyTaskRoute from './daily-task/daily-task.routes.js';
import taskRoutes from './task/task.routes.js';
import teamRoutes from './team/team.routes.js';
import faultRoute from './fault/fault.routes.js';
import userRoute from './user/user.routes.js';
import toolRoute from './tool/tool.routes.js';
import materialRoute from './material/material.routes.js';
import fireFileRoute from './firefile/firefile.routes.js';
import dictRoute from './dict/dict.routes.js';
import workReportRoute from './work-report/work-report.routes.js';
import workLogRoute from './work-log/work-log.routes.js';

// gnmk 模块首页路由
const homeRoute = {
  path: 'home',
  name: 'gnmkHome',
  component: () => import('./home/index.vue'),
  meta: {
    navtabTitle: '消防管理首页',
    isCache: true,
    ignoreDiff: [],
    menuElements: []
  }
};

const FEATURES_ROUTES = [
  homeRoute,
  areaRoutes,
  deviceTypeRoutes,
  deviceRoutes,
  ...checkContentRoutes,
  ...taskRoutes,
  dailyTaskRoute,
  teamRoutes,
  faultRoute,
  userRoute,
  toolRoute,
  materialRoute,
  fireFileRoute,
  dictRoute,
  workReportRoute,
  workLogRoute
];

/**
 * 功能模块扩展路由配置
 * 包含：区域管理、设施类型管理、设备台账管理、任务管理、人员小组管理
 */
const gnmkRoutes = {
  path: 'gnmk',
  name: 'gnmk',
  component: { template: '<router-view></router-view>' },
  children: [...FEATURES_ROUTES]
};

export default gnmkRoutes;
